import AddedToCartNotification from "../../src/component/custom/AddedToCartNotification";
import ContactUsPopup from "../../src/component/custom/ContactUsPopup";
import InventoryAlertForAddToCartPopup from "../../src/pages/Cart/CartModals/InventoryAlertForAddToCartPopup";
import SendEmailOfReportError from "../../src/pages/ProductDetail/SendEmailOfReportError";
import SendEmailOfCurrentPage from "../../src/pages/ProductListing/SendEmailOfCurrentPage";
import QuotePopup from "../../src/pages/Quote/QuoteModals/QuotePopup";
import DateSchedulePopup from "../../src/pages/Cart/CartModals/DateSchedulePopup";
import AddToBOMPopup from "../../src/pages/Cart/CartModals/AddToBOMPopup";
import ClearCartPopup from "../../src/pages/Cart/CartModals/ClearCartPopup";
import ShareCartPopup from "../../src/pages/Cart/CartModals/ShareCartPopup";
import ClearQuotePopup from "../../src/pages/Quote/QuoteModals/ClearQuotePopup";
import DeleteQuotePopup from "../../src/pages/Quote/QuoteModals/DeleteQuotePopup";
import SubmitQuotePopup from "../../src/pages/Quote/QuoteModals/SubmitQuotePopup";
import AddedPartQuotePopup from "../../src/pages/Quote/QuoteModals/AddedPartQuotePopup";
import QuoteDetailFilterPopup from "../../src/pages/Quote/QuoteModals/QuoteDetailFilterPopup";
import QuoteMessagePopup from "../../src/pages/Quote/QuoteModals/QuoteMessagePopup";
import ConfirmationPopup from "src/pages/Quote/QuoteModals/ConfirmationPopup";
import CreatePartPopup from "../../src/pages/BOM/BomModals/CreatePartPopup";
import FindPartPopup from "../../src/pages/BOM/BomModals/FindPartPopup";
import AddedToBomPopup from "../../src/pages/BOM/BomModals/AddedToBomPopup";
import BomSearchMatchPopup from "../../src/pages/BOM/BomModals/BomSearchMatchPopup";
import DownloadBomPopup from "../../src/pages/BOM/BomModals/DownloadBomPopup";
import BomEditColumnsPopup from "../../src/pages/BOM/BomModals/BomEditColumnsPopup";
import AlternativeBomPopup from "../../src/pages/BOM/BomModals/AlternativeBomPopup";
import BomCreateProjectPopup from "../../src/pages/BOM/BomModals/BomCreateProjectPopup";
import BomDeleteProjectPopup from "../../src/pages/BOM/BomModals/BomDeleteProjectPopup";
import BomDeletePopup from "../../src/pages/BOM/BomModals/BomDeletePopup";
import AddedToCartBomPopup from "../../src/pages/BOM/BomModals/AddedToCartBomPopup";
import OrderHistoryEmailPopUp from "../../src/pages/Order/OrderModals/OrderHistoryEmailPopup";
import OrderDetailEmailSalesPopup from "src/pages/Order/OrderModals/OrderDetailEmailSalesPopup";
import OrderDetailEmailSendStatusPopup from "src/pages/Order/OrderModals/OrderDetailEmailSendStatusPopup";
import OrderDetailEmailItemStatusPopup from "src/pages/Order/OrderModals/OrderDetailEmailItemStatusPopup";
import ThankYouPopup from "../../src/component/custom/ThankYouPopup";
import ReturnToCartPopup from "src/pages/Checkout/CheckoutModals/ReturnToCartPopup";
import GuestPopupActionButton from "src/component/custom/GuestPopupActionButton";
import ProductImagePopup from "../../src/pages/ProductDetail/ProductImagePopup";
import FilterSelectionPopup from "../../src/pages/ProductListing/FilterSelectionPopup";
import QuoteAdvanceFilterPopup from "../../src/pages/Quote/QuoteModals/QuoteAdvanceFilterPopup";
import ValidateRFQQuoteRequest from "../../src/pages/Quote/QuoteModals/ValidateRFQQuoteRequest";
import CartItemReplacePopup from "src/pages/Cart/CartModals/CartItemReplacePopup";
import BomToCartItemReplacePopup from "src/pages/Cart/CartModals/BomToCartItemReplacePopup";
import QuoteDateSchedulePopup from "src/pages/Cart/CartModals/QuoteDateSchedulePopup";
import AddUser from "src/pages/Admin/AdminModals/AddUser";
import RemoveUser from "src/pages/Admin/AdminModals/RemoveUser";
import UnsponsorUserAcct from "src/pages/Admin/AdminModals/UnsponsorUserAcct";
import SponsorUserAcct from "src/pages/Admin/AdminModals/SponsorUserAcct";
import RoleSelection from "src/pages/Admin/AdminModals/RoleSelection";
import PriceMisMatch from "src/pages/Cart/CartModals/PriceMisMatch";
import PriceMisMatchBackOrder from "src/pages/Cart/CartModals/PriceMisMatchBackOrder";
import CartPriceMisMatchBackOrder from "src/pages/Cart/CartModals/CartPriceMisMatchBackOrder";
import RegisterDesignPopup from "src/pages/BOM/BomListing/RegisterDesignPopup";
import ProfileAddressPopup from "src/pages/Profile/profileModals/ProfileAddressPopup";
import VerifyAddressPopup from "src/pages/Profile/profileModals/VerifyAddressPopup";
import ContactInformationPopup from "src/pages/Profile/profileModals/ContactInformationPopup";
import ContactPopup from "src/component/custom/ContactPopup";
import BomWarningPopUp from "src/pages/BOM/BomModals/BomWarningPopup";
import ExportCompliance from "src/pages/Checkout/CheckoutModals/ExportCompliance";
import SaveShippingMethod from "src/pages/Checkout/CheckoutModals/SaveShippingMethod";
import PlaceOrderFeedback from "src/pages/Checkout/CheckoutModals/PlaceOrderFeedback";
import BackorderNotAvailable from "src/pages/Cart/CartModals/BackorderNotAvailablePopup";
import OrderAdvanceFilterPopup from "../../src/pages/Order/OrderModals/OrderAdvanceFilterPopup";
import EmailSentPopup from "src/component/custom/EmailSentPopup";
import OrderReleasesPopup from "src/pages/Order/OrderModals/OrderReleasesPopup";
import SurveyResponse from "src/pages/Admin/AdminModals/SurveyResponse";
import ShippingAddressPopup from "src/pages/Admin/userManagement/ShippingAddressPopup";
import OrderDetailViewInvoicesPopup from "src/pages/Order/OrderModals/OrderDetailViewInvoicesPopup"
import OrderHistoryCancellationPopup from "src/pages/Order/OrderModals/OrderHistoryCancellationPopup";
import OrderDetailViewAllTrackingPopup from "src/pages/Order/OrderModals/OrderDetailViewAllTrackingPopup";
import CheckoutConfirmationPopup from "src/pages/Cart/CartModals/CheckoutConfirmationPopup";
import ProductBackorderedPopup from "src/pages/Cart/CartModals/ProductBackorderedPopup";

class ModalPopup {
        static chain = [
                { name: 'ContactUsPopup', element: ContactUsPopup },
                { name: 'ContactPopup', element: ContactPopup },
                { name: 'AddedToCartNotification', element: AddedToCartNotification },
                { name: 'InventoryAlertForAddToCartPopup', element: InventoryAlertForAddToCartPopup },
                { name: 'SendEmailOfReportError', element: SendEmailOfReportError },
                { name: 'SendEmailOfCurrentPage', element: SendEmailOfCurrentPage },
                { name: 'QuotePopup', element: QuotePopup },
                { name: 'DateSchedulePopup', element: DateSchedulePopup },
                { name: 'AddToBOMPopup', element: AddToBOMPopup },
                { name: 'ClearCartPopup', element: ClearCartPopup },
                { name: 'ShareCartPopup', element: ShareCartPopup },
                { name: 'ClearQuotePopup', element: ClearQuotePopup },
                { name: 'DeleteQuotePopup', element: DeleteQuotePopup },
                { name: 'SubmitQuotePopup', element: SubmitQuotePopup },
                { name: 'AddedPartQuotePopup', element: AddedPartQuotePopup },
                { name: 'QuoteDetailFilterPopup', element: QuoteDetailFilterPopup },
                { name: 'QuoteMessagePopup', element: QuoteMessagePopup },
                { name: 'ConfirmationPopup', element: ConfirmationPopup },
                { name: 'CreatePartPopup', element: CreatePartPopup },
                { name: 'FindPartPopup', element: FindPartPopup },
                { name: 'AddedToBomPopup', element: AddedToBomPopup },
                { name: 'BomSearchMatchPopup', element: BomSearchMatchPopup },
                { name: 'DownloadBomPopup', element: DownloadBomPopup },
                { name: 'BomEditColumnsPopup', element: BomEditColumnsPopup },
                { name: 'AlternativeBomPopup', element: AlternativeBomPopup },
                { name: 'BomCreateProjectPopup', element: BomCreateProjectPopup },
                { name: 'BomDeleteProjectPopup', element: BomDeleteProjectPopup },
                { name: 'BomDeletePopup', element: BomDeletePopup },
                { name: 'AddedToCartBomPopup', element: AddedToCartBomPopup },
                { name: 'OrderHistoryEmailPopUp', element: OrderHistoryEmailPopUp },
                { name: 'OrderDetailEmailSalesPopup', element: OrderDetailEmailSalesPopup },
                { name: 'OrderDetailEmailSendStatusPopup', element: OrderDetailEmailSendStatusPopup },
                { name: 'OrderDetailEmailItemStatusPopup', element: OrderDetailEmailItemStatusPopup },
                { name: 'ThankYouPopup', element: ThankYouPopup },
                { name: 'GuestPopupActionButton', element: GuestPopupActionButton },
                { name: 'ProductImagePopup', element: ProductImagePopup },
                { name: 'FilterSelectionPopup', element: FilterSelectionPopup },
                { name: 'QuoteAdvanceFilterPopup', element: QuoteAdvanceFilterPopup },
                { name: 'ValidateRFQQuoteRequest', element: ValidateRFQQuoteRequest },
                { name: 'CartItemReplacePopup', element: CartItemReplacePopup },
                { name: 'BomToCartItemReplacePopup', element: BomToCartItemReplacePopup },
                { name: 'QuoteDateSchedulePopup', element: QuoteDateSchedulePopup },
                { name: 'AddUser', element: AddUser },
                { name: 'RemoveUser', element: RemoveUser },
                { name: 'UnsponsorUserAcct', element: UnsponsorUserAcct },
                { name: 'SponsorUserAcct', element: SponsorUserAcct },
                { name: 'RoleSelection', element: RoleSelection },
                { name: 'PriceMisMatch', element: PriceMisMatch },
                { name: 'PriceMisMatchBackOrder', element: PriceMisMatchBackOrder },
                { name: 'CartPriceMisMatchBackOrder', element: CartPriceMisMatchBackOrder },
                { name: 'RegisterDesignPopup', element: RegisterDesignPopup },
                { name: 'ProfileAddressPopup', element: ProfileAddressPopup },
                { name: 'VerifyAddressPopup', element: VerifyAddressPopup },
                { name: 'ShippingAddressPopup', element: ShippingAddressPopup },
                { name: 'ContactInformationPopup', element: ContactInformationPopup },
                { name: 'ReturnToCartPopup', element: ReturnToCartPopup },
                { name: 'BomWarningPopUp', element: BomWarningPopUp },
                { name: 'ExportCompliance', element: ExportCompliance },
                { name: 'SaveShippingMethod', element: SaveShippingMethod },
                { name: 'BackorderNotAvailable', element: BackorderNotAvailable },
                { name: 'OrderAdvanceFilterPopup', element: OrderAdvanceFilterPopup },
                { name: 'EmailSentPopup', element: EmailSentPopup },
                { name: 'OrderReleasesPopup', element: OrderReleasesPopup },
                { name: 'SurveyResponsePopUp', element: SurveyResponse },
                { name: 'OrderDetailViewInvoicesPopup', element: OrderDetailViewInvoicesPopup },
                { name: 'OrderHistoryCancellationPopup', element: OrderHistoryCancellationPopup },
                {name: 'OrderDetailViewAllTrackingPopup', element: OrderDetailViewAllTrackingPopup },
                {name: 'PlaceOrderFeedback', element: PlaceOrderFeedback },
                {name: 'CheckoutConfirmationPopup', element: CheckoutConfirmationPopup },
                {name: 'ProductBackorderedPopup', element: ProductBackorderedPopup },
                

        ];
}

export default ModalPopup;